import { render } from "./HiPagination.vue?vue&type=template&id=86fca35c&scoped=true"
import script from "./HiPagination.vue?vue&type=script&lang=js"
export * from "./HiPagination.vue?vue&type=script&lang=js"

import "./HiPagination.vue?vue&type=style&index=0&id=86fca35c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86fca35c"]])

export default __exports__